import {types} from './types';

export function setCustomisation(data) {
  return {
    type: types.CUSTOMISATION,
    payload: data,
  };
}
